import React, {useState, useEffect} from "react";
import {Redirect, useLocation} from "react-router-dom";

const GetNewProject = () => {
    const location = useLocation();
    const [redirectTo, setRedirectTo] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        let mounted = true;
        // 10s timer: if we haven’t redirected by then, show error
        const timer = setTimeout(() => {
            if (mounted && !redirectTo) {
                setError("No valid link detected. Please try again.");
            }
        }, 10000);

        const searchParams = new URLSearchParams(location.search);
        let hash = searchParams.get("hash");

        if (!hash && location.pathname.includes("hash=")) {
            hash = location.pathname.split("hash=")[1];
        }

        if (hash) {
            try {
                const decoded = atob(hash);
                const params = new URLSearchParams(decoded);
                const projectId = params.get("projectId");
                const user = params.get("user");

                if (projectId && user) {
                    localStorage.setItem("projectId", projectId);
                    localStorage.setItem("user", user);
                    setRedirectTo(`/project/${projectId}/details`);
                } else {
                    setError("Invalid link data. Please check your link and try again.");
                }
            } catch (err) {
                setError("Malformed link. Unable to decode.");
            }
        }

        return () => {
            mounted = false;
            clearTimeout(timer);
        };
    }, [location, redirectTo]);

    // if we got the right ID & user, redirect
    if (redirectTo) {
        return <Redirect to={redirectTo}/>;
    }

    return (
        <div style={{padding: 16, textAlign: "center"}}>
            {error ? (
                <p style={{color: "red"}}>{error}</p>
            ) : (
                <p>Loading… if you’ve been redirected here, your project will open shortly.</p>
            )}
        </div>
    );
};

export default GetNewProject;
